// import React from 'react';

// const ShowRuler = ({ rulerStatus, setRulerStatus, lengthCable, lengthCableSegment }) => {

//   const сloseModal = () => {
//     setRulerStatus(false);
//   };

//   if (rulerStatus) {
//     return (
//       <div className="divRuler">
//         <label style={{ color: '#d1d1d1', fontSize: "16px" }}>Линейка</label>  
//         <hr className='horizontalLineModalUpTer' />
//         <button  class='buttonEditingLineSave'style={{marginRight: "5px"}} > Мерять</button>
//         <button  class='buttonEditingLineSave'style={{marginRight: "5px"}} > Сбросить</button>
//         <button  class='buttonEditingLineСancel' onClick={сloseModal}> Закрыть</button>
//       </div>
//     );
//   } else {
//     return null;
//   }


import React from 'react';

const ShowRuler = ({ rulerStatus, setRulerStatus, enableRuler, resetRuler}) => {
  const closeModal = () => {
    setRulerStatus(false);
  };

  if (rulerStatus) {
    return (
      <div className="divRuler">
        <label style={{ color: '#d1d1d1', fontSize: "16px" }}>Линейка</label>
        <hr className='horizontalLineModalUpTer' />
        <button className='buttonEditingLineSave2' style={{ marginRight: "5px" }} onClick={enableRuler}>Начать</button>
        <button className='buttonEditingLineSave' style={{ marginRight: "5px" }} onClick={resetRuler}>Сбросить</button>
        <button className='buttonEditingLineСancel' onClick={closeModal}>Закрыть</button>
      </div>
    );
  } else {
    return null;
  }
}

export default ShowRuler;